import { render, staticRenderFns } from "./OfficialResources.vue?vue&type=template&id=07bb61e9&scoped=true&"
import script from "./OfficialResources.vue?vue&type=script&lang=js&"
export * from "./OfficialResources.vue?vue&type=script&lang=js&"
import style0 from "./OfficialResources.vue?vue&type=style&index=0&id=07bb61e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bb61e9",
  null
  
)

export default component.exports